<app-landingsside-admin *ngIf="isAdmin"></app-landingsside-admin>
<app-landingsside-maskinist *ngIf="isMaskinist"></app-landingsside-maskinist>


